export default __webpack_public_path__ + "7d3b790e4865aec8162515b9283bf31d.svg";